<template>
  <v-container fluid class="fs-admin-container">
    <v-row>
      <v-col>
        <Select
          v-model="subject"
          :disabled="parent.has_limited_access"
          :items="supportRequestsConstants"
          :rules="[v => !!v || 'Укажите тему']"
          item-text="name"
          item-value="id"
          label="Тема сообщения"
          required
        />
        <v-textarea
          v-model="message"
          autocomplete="Сообщение..."
          label="Сообщение"
        ></v-textarea>
        <v-btn
          :disabled="subject === null || !message.trim().length || parent.has_limited_access"
          color="success"
          class="mr-4"
          @click="sendMessage"
        >
          Отправить
        </v-btn>
      </v-col>
      <v-col>
        <div v-if="phoneContacts.length">
          <h2>Телефоны тех поддержки</h2>
          <ul>
            <li v-for="contact in phoneContacts" :key="contact.id">{{ contact.contact }}</li>
          </ul>
        </div>
        <div class="mt-4" v-if="emailContacts.length">
          <h2>Email тех поддержки</h2>
          <ul>
            <li v-for="contact in emailContacts" :key="contact.id">
              <a :href="`mailto:${contact.contact}`" target="_blank">
                {{ contact.contact }}
              </a>
            </li>
          </ul>
        </div>
        <div class="mt-4" v-if="webContacts.length">
          <h2>Сайты</h2>
          <ul>
            <li v-for="contact in webContacts" :key="contact.id">
              <a :href="contact.contact" target="_blank">
                {{ contact.contact }}
              </a>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { Select } from '@/components/common'
import { GET_SUPPORT_CONTACTS, SEND_SUPPORT_MESSAGE } from '@/requests/parent'

export default {
  name: 'SupportParent',
  components: {
    Select
  },
  data() {
    return {
      contacts: [],
      subject: null,
      message: '',
      checkbox: false,
    }
  },
  mounted() {
    this.subject = this.supportRequestsConstants[0].id
    this.loadSupportContacts()
  },
  computed: {
    ...mapState({
      childId: state => state.child.childId,
      parent: state => state.child.data.parent,
      supportRequestsConstants: state => state.common.constants.support_requests_types,
      contactTypes: state => state.common.constants.contact_types
    }),
    emailContacts() {
      const emailContactType = this.contactTypes.find(c => c.alias === 'EMAIL')
      return this.contacts.filter(c => c.contact_type === emailContactType.id)
    },
    phoneContacts() {
      const phoneContactType = this.contactTypes.find(c => c.alias === 'PHONE')
      return this.contacts.filter(c => c.contact_type === phoneContactType.id)
    },
    webContacts() {
      const webContactType = this.contactTypes.find(c => c.alias === 'WEB')
      return this.contacts.filter(c => c.contact_type === webContactType.id)
    }
  },
  methods: {
    async loadSupportContacts() {
      try {
        const { data: { results }} = await GET_SUPPORT_CONTACTS()
        this.contacts = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось получить список '
        })
      }
    },
    async sendMessage () {
      try {
        await SEND_SUPPORT_MESSAGE(this.childId, {
          subject: this.subject,
          message: this.message.trim()
        })
        this.$notify({
          type: 'success',
          text: 'Сообщение успешно отправлено в тех поддержку'
        })

        this.subject = this.supportRequestsConstants[0].id
        this.message = ''
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось отправить сообщение в тех поддержку'
        })
      }
    }
  },
}
</script>